/**
 * Кнопка-фишка отбора: год, период, площадка.
 *
 * Общая для отбора на нескольких экранах («Спрос», «Статистика», «Планы»,
 * карточка товара) НАМЕРЕННО: один и тот же вид чипа обещает один и тот же
 * смысл отбора, а разъехавшийся вид означал бы, что это разные отборы, — а
 * это один и тот же.
 */
export function Chip({
  label,
  on,
  title,
  onClick,
}: {
  label: string;
  on: boolean;
  title: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className={
        "h-8 rounded-[var(--radius-ui)] border px-2 text-[12.5px] transition-colors " +
        (on
          ? "border-accent bg-accent-dim font-medium text-accent-text"
          : "border-border bg-bg text-fg-muted hover:text-fg")
      }
    >
      {label}
    </button>
  );
}
